<script>
import checkIcon from '../assets/check.svg'
import failIcon from '../assets/fail.svg'
export default {
  props: {
    isActived: {
      type: Boolean,
      default: false
    },
    desc: {
      type: String,
      default: ''
    },
    num: {
      type: Number,
      default: 1
    },
    isPass: {
      type: Boolean,
      default: false
    },
    isChecked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkIcon,
      failIcon
    }
  }
}
</script>
<template>
  <div class="steps-item">
    <div
      class="steps-item-num-wrapper"
      :class="{
        'steps-item-num-wrapper__inactive': !isActived,
        'steps-item-num-wrapper__pass': isPass && isChecked
      }"
    >
      <div
        class="steps-item-num"
        :class="{
          'steps-item-num__inactive': !isActived
        }"
      >
        <template v-if="!isChecked">
          {{ num }}
        </template>
        <template v-else-if="isPass && isChecked">
          <img :src="checkIcon" class="check-icon" alt="check" />
        </template>
        <template v-else-if="!isPass && isChecked">
          <img :src="failIcon" class="fail-icon" alt="fail" />
        </template>
      </div>
    </div>
    <div
      class="steps-item-desc"
      :class="{
        'steps-item-desc__inactive': !isActived,
        'steps-item-num-wrapper__fail': !isPass && isChecked
      }"
    >
      {{ desc }}
    </div>
  </div>
</template>
<style scoped>
.steps-item {
  width: fit-content;
  height: fit-content;
}
.steps-item-num-wrapper {
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #d0d5ed;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  overflow: visible;
}
.steps-item-num-wrapper__pass {
  background-color: #4c6ef5;
}
.steps-item-num {
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0px;
  text-align: center;
  color: #ffffff;
  background-color: #4c6ef5;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: visible;
}
.steps-item-desc {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 16px;
  line-height: 14px;
  text-align: center;
  color: #4c6ef5;
  margin-top: 12px;
}

.steps-item-num-wrapper__inactive {
  background-color: #d1d7e1;
}
.steps-item-num__inactive {
  background-color: #d1d7e1;
}
.steps-item-desc__inactive {
  color: #868e96;
}
.steps-item-num-wrapper__fail {
  color: #ff5858;
}
.check-icon {
  width: 17px;
}
.fail-icon {
  width: 32px;
  height: 32px;
  background-color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
